import React from 'react';
import { fill_placeholders, round_to } from '../utils';

const Extruded = ({
  active,
  chunk_by,
  chart_height,
  chart_width,
  onClick,
  round,
  stroke,
  stroke_width,
}) => {
  let filtered = active;

  if (chart_width > 250) {
    let l = active.length;
    if (l < chunk_by) {
      const fillers = chunk_by - l;
      if (fillers % 2 === 0) {
        let placeholder = fillers / 2;
        let temp = fill_placeholders(active, placeholder, true);
        filtered = fill_placeholders(temp, placeholder, false);
      } else {
        let placeholder = -~((chunk_by - l) / 2);
        let temp = fill_placeholders(active, placeholder - 1, true);
        filtered = fill_placeholders(temp, placeholder, false);
      }
    }
  }

  const s = 1;

  const bars = filtered.map(({ color, label, raw, value, id }, index) => {
    let h = chart_width / filtered.length;
    let w = chart_width / filtered.length;
    let spacing_tiles = 3;
    const extruded = value === 0 ? 2 : round_to(value / 4, 0);
    const tiles = new Array(extruded).fill('*');

    if (label === 'placeholder')
      return (
        <g key={index}>
          <rect
            stroke={'rgba(120,120,120,.6'}
            fill={color}
            strokeWidth="2"
            x={0}
            y={chart_height}
            width={w}
            height={w}
            style={{
              opacity: 0,
              transformOrigin: 'center center',
              transform: `translateX(${index * w}px) scale3d(${s},${s},${s}) `,
            }}
          />
        </g>
      );
    return (
      <g key={index}>
        {tiles.map((x, i) => (
          <rect
            key={i}
            stroke={'rgba(120,120,120,.6'}
            fill={color}
            strokeWidth="2"
            onClick={() => onClick({ raw, label })}
            x={0}
            y={chart_height - h}
            width={w}
            height={w}
            style={{
              cursor: 'pointer',
              transformOrigin: 'center center',
              transform: `translateX(${index * w}px) translateY(-${1 +
                i * spacing_tiles}px)scale3d(${s},${s},${s}) `,
            }}
          />
        ))}
      </g>
    );
  });

  return (
    <g
      aria-hidden="true"
      strokeWidth={stroke_width}
      stroke={stroke}
      strokeLinecap={round ? 'round' : 'square'}
      strokeLinejoin={round ? 'round' : 'miter'}
    >
      {bars}
    </g>
  );
};
export default Extruded;
